import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Container, GoldButton, OutlineButton } from "@/components/shared";
import { PLANS } from "@/data/plans";
import { useAuth } from "@/context/AuthContext";

export default function Join() {
  const { user } = useAuth();

  return (
    <div>
      <PageHero
        kicker="Membership · A free profile. Paid trade."
        title="List your business on the crossing"
        intro="Every business gets one free company profile in the sector directory — no one is priced out of being found. To publish products and services on the Trade floor, and to post freely in the members' forum, choose a paid tier. Prices are shown here; card payment is coming next."
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PLANS.map((p) => (
              <div
                key={p.key}
                data-testid={`plan-card-${p.key}`}
                className={`relative bg-[#FFFAF3] p-8 flex flex-col ${
                  p.popular ? "border-2 border-[#CDA434] shadow-md" : "border border-[#D6D3CB]"
                }`}
              >
                {p.popular && (
                  <span className="absolute -top-3 left-8 bg-[#CDA434] text-[#1E1E2F] text-[10px] font-sans font-bold uppercase tracking-widest px-3 py-1">
                    Most chosen
                  </span>
                )}
                <h3 className="font-serif text-2xl text-[#1E1E2F]">{p.name}</h3>
                <div className="mt-3 mb-1">
                  <span className="font-serif text-3xl text-[#003366]">{p.price_month}</span>
                </div>
                <p className="font-sans text-xs text-[#505A68] h-4">{p.price_year}</p>
                <p className="font-playfair italic text-sm text-[#7a611c] mt-4">{p.tagline}</p>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 font-sans text-sm text-[#1B2430]">
                      <Check size={15} className="text-[#CDA434] mt-0.5 shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  {user ? (
                    <GoldButton as="link" to="/account" className="w-full">Choose in your account</GoldButton>
                  ) : (
                    <GoldButton as="link" to="/signup" className="w-full">Create an account</GoldButton>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 max-w-3xl mx-auto text-center bg-[#FFFAF3] border border-[#D6D3CB] p-10">
            <h2 className="font-serif text-2xl text-[#1E1E2F] mb-3">How listing works</h2>
            <p className="font-sans text-base text-[#1B2430] leading-relaxed">
              Create an account, submit your business, and it enters the queue as <em>pending</em>.
              An independent moderator reviews every listing before it goes live, so the directory
              stays honest. Once approved, your listing appears on the Made directory and any
              enquiries land in your account inbox.
            </p>
            <div className="mt-6 flex justify-center gap-3">
              {user ? (
                <GoldButton as="link" to="/account/listing/edit">Submit your listing</GoldButton>
              ) : (
                <>
                  <GoldButton as="link" to="/signup">Get started</GoldButton>
                  <OutlineButton as="link" to="/signin" className="px-6 py-3">Sign in</OutlineButton>
                </>
              )}
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
